export default {
    title: 'Xlsx Export',
    description: 'Exportiere die ausgewählten Bezirke im Xlsx Format.',
    exportRegions: 'Exportieren'
}